import axios from 'axios';
import moment from 'moment';
const invoices_url = 'invoices/';
const progress_invoice_url = 'progress-invoice/';
const progress_invoice_email_url = 'send-progress-invoice/';
const email_invoice_url = 'email-invoice/';
const email_outstanding_notice_url = 'email-outstanding-notice/';
const email_invoice_overdue_notice = 'email-overdue-notice/';
const preview_invoice_url = 'preview-invoice/';
const invoice_line_items_url = 'invoice-line-items/';
const invoice_lookup_url = 'invoice-lookup/';
const invoice_payments_url = 'invoice-payments/';
const reconciliations_url = 'reconciliations/';
const accounts_url = 'accounts/';
const account_groups_url = 'account-groups/';
const deposits_url = 'deposits/';
const accounting_dashboard_url = 'accounting-dashboard/';
const ar_report_url = 'ar-report/';
const journal_entry_url = 'journal-entries/';
const journal_entry_line_items_url = 'journal-entry-line-items/';
const journal_entry_line_items_by_reconciliation_url = 'journal-entry-line-items-by-reconciliation/';
const expenses_url = 'expenses/';
const expense_line_items_url = 'expense-line-items/';
const create_statement_url = 'create-statement/';
const invoice_templates_url = 'invoice-templates/';
const preview_invoice_template_url = 'preview-invoice-template/';
const activate_invoice_template_url = 'activate-invoice-template/';

export default {
    async getAccountingDashboard(){
        return axios.get(accounting_dashboard_url)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async getInvoices(){
        const url = invoices_url + '?is_template=false';
        return axios.get(url)
        .then((response) => {
            return response.data
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async getInvoice(id){
        const url = invoices_url + `${id}/`;
        return axios.get(url)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async createInvoice(invoice){
        return axios.post(invoices_url, invoice).then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async updateInvoice(id, invoice){
        const url = invoices_url + `${id}/`;
        return axios.patch(url, invoice)
        .then((response) => {
            return response.data
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async postInvoice(id, invoice){
        const url = invoices_url + `${id}/?was_sent=true`;
        return axios.patch(url, invoice)
        .then((response) => {
            return response.data
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async unpostInvoice(id, invoice){
        const url = invoices_url + `${id}/?un_post=true`;
        return axios.patch(url, invoice)
        .then((response) => {
            return response.data
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async deleteInvoice(id){
        const url = invoices_url + `${id}/`;
        return axios.delete(url).then((response) => {
            return response.data
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async getOverdueInvoices(){
        const url = invoices_url + '?overdue_report=true';
        return axios.get(url)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async getArchivedInvoices(){
        const url = invoices_url + '?archived_report=true';
        return axios.get(url)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async getUncollectibleInvoices(){
        const url = invoices_url + '?uncollectible_report=true';
        return axios.get(url)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async getUnpaidInvoices(from, to, ignore_small){
        let url = invoices_url + '?unpaid_report=true&';

        if(from !== null && from !== undefined){
            url += `from_date=${from}&`;
        }

        if(to !== null && to !== undefined){
            url += `to_date=${to}&`;
        }

        if(ignore_small !== null && ignore_small !== undefined){
            url += `ignore_small=${ignore_small}`;
        }
        
        return axios.get(url)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async getUnsentInvoices(){
        const url = invoices_url + '?unsent_report=true';
        return axios.get(url)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async getPaidInvoices(){
        const url = invoices_url + '?paid_report=true';
        return axios.get(url)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async invoiceLookup(val, unpaid, exact){
        let url = invoice_lookup_url + `?v=${val}&`;

        if(unpaid !== null && unpaid !== undefined && unpaid !== false){
            url += 'is_unpaid=true&';
        }

        url += `exact=${exact}&`;

        return axios.get(url)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async getRevenueInvoices(sent_from, sent_to){
        let url = invoices_url + '?';

        url += 'revenue_report=true&';
        url += 'is_template=false&';
        url += 'archived=false&';

        if(sent_from !== null && sent_from !== undefined){
            url += `sent_from=${sent_from}&`;
        }

        if(sent_to !== null && sent_to !== undefined){
            url += `sent_to=${sent_to}&`;
        }
      
        return axios.get(url)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async createProgressInvoice(progress_invoice){
        return axios.post(progress_invoice_url, progress_invoice).then((response) => {
            return response.data;
        }).catch(err => {   
            console.log(err.response.data);
        });
    },
    async updateProgressInvoice(id, progress_invoice){
        const url = progress_invoice_url + `${id}/`;
        return axios.patch(url, progress_invoice)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async deleteProgressInvoice(id){
        const url = progress_invoice_url + `${id}/`;
        return axios.delete(url).then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async sendProgressInvoiceEmail(id){
        const url = progress_invoice_email_url + `?pk=${id}`;
        return axios.post(url).then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async getARReport(as_at){
        const url = ar_report_url +`?date=${as_at}`;
        return axios.get(url)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async emailInvoice(id){
        const url = email_invoice_url + `?pk=${id}&`;
        return axios.post(url, {}).then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async emailInvoiceOutstandingNotice(id){
        const url = email_outstanding_notice_url + `?pk=${id}&`;
        return axios.post(url, {})
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async emailInvoiceOverdueNotice(id){
        const url = email_invoice_overdue_notice + `?pk=${id}&`;
        return axios.post(url, {})
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async previewInvoice(id){
        const url = preview_invoice_url + `${id}/`;
        return axios.get(url)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async toggleInvoiceUncollectible(id, uncollectible_date, is_uncollectible){
        const url = invoices_url + `${id}/?toggle_uncollectible=true&`;
        const body = {
            "uncollectible_date": uncollectible_date,
            "is_uncollectible": is_uncollectible
        }

        return axios.patch(url, body)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async getEstimateInvoices(id){
        const url = invoices_url + `?estimate_pk=${id}&is_template=true&`;
        return axios.get(url)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async getFullEstimateInvoices(id){
        const url = invoices_url + `?estimate_pk=${id}`;
        return axios.get(url)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async getProjectInvoices(id){
        const url = invoices_url + `?project=${id}`;
        return axios.get(url)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async sendStatement(project_id, invoice_ids, email_data){
        let url = create_statement_url + `?project_pk=${project_id}&`;
        invoice_ids.map((id => {
            url += `invoice_pk=${id}&`;
        }));
        return axios.post(url, email_data)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async getLineItems(id){
        const url = invoice_line_items_url + `?invoice=${id}`;
        return axios.get(url)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async getAccountLineItems(start_date, end_date, account_id, division, no_account){
        let url = invoice_line_items_url + `?start_date=${start_date}&end_date=${end_date}&`;

        if(account_id !== null && account_id !== undefined){
            url += `account_id=${account_id}&`;
        }

        if(division !== null && division !== undefined){
            url += `division=${division}&`;
        }

        if(no_account !== null && no_account !== undefined){
            url += `no_account=true&`;
        }

        return axios.get(url)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        })
    },
    async updateInvoiceLineItem(id, line_item){
        const url = invoice_line_items_url + `${id}/`;
        return axios.patch(url, line_item)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async updateInvoiceLineItemOrder(update_array){
        const url = invoice_line_items_url + 'order/';
        return axios.post(url, update_array)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async createInvoiceLineItem(line_item){
        return axios.post(invoice_line_items_url, line_item)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async deleteInvoiceLineItem(id){
        const url = invoice_line_items_url + `${id}/`;
        return axios.delete(url)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async getInvoicePayments(id){
        const url = invoice_payments_url + `?invoice=${id}`;
        return axios.get(url)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async createInvoicePayment(payment){
        return axios.post(invoice_payments_url, payment)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async updateInvoicePayment(id, payment){
        const url = invoice_payments_url + `${id}/`;
        return axios.patch(url, payment)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async deleteInvoicePayment(id){
        const url = invoice_payments_url + `${id}/`;
        return axios.delete(url)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async getAccounts(){
        return axios.get(accounts_url)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async createAccount(account){
        return axios.post(accounts_url, account)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async updateAccount(id, account){
        const url = accounts_url + `${id}/`;
        return axios.patch(url, account).then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async getAccountGroups(){
        return axios.get(account_groups_url)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async getPaymentAccounts(){
        const url = accounts_url + `?can_pay_with=true&`;
        return axios.get(url)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async getDepositAccounts(){
        const url = accounts_url + `?can_deposit=true&`;
        return axios.get(url)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async getBalanceSheetAccounts(as_at){
        let url = accounts_url + `balance_sheet?`;

        if(as_at !== null && as_at !== undefined){
            as_at = moment().format('YYYY-MM-DD').toString();
            url += `as_at=${as_at}&`;
        }
    
        return axios.get(url)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async getProfitAndLossAccounts(from, to){
        let url = accounts_url + 'profit_and_loss/?';

        if(from !== null && from !== undefined){
            url += `from=${from}&`;
        }

        if(to !== null && to !== undefined){
            url += `to=${to}&`;
        }else{

            url += `to=${moment().format('YYYY-MM-DD').toString()}`;
        }
    
        return axios.get(url)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async getAccountTransactions(id, from, to){
        let url = journal_entry_line_items_url + `?account=${id}&`;

        if(from !== null && from !== undefined){
            url += `from_date=${from}&`;
        }

        if(to !== null && to !== undefined){
            url += `to_date=${to}&`;
        }else{

            url += `to_date=${moment().format('YYYY-MM-DD').toString()}`;
        }
    
        return axios.get(url)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async getAccountTransactionsByReconciliation(from, to, account){
        let url = journal_entry_line_items_by_reconciliation_url + `?`;

        if(from !== null && from !== undefined){
            url += `from_date=${from}&`;
        }

        if(to !== null && to !== undefined){
            url += `to_date=${to}&`;
        }else{
            url += `to_date=${moment().format('YYYY-MM-DD').toString()}&`;
        }

        if(account !== null && account !== undefined){
            url += `account=${account}&`;
        }

        return axios.get(url)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async getRevenueAccounts(){
        const url = accounts_url + '?account_type=R&is_grouping=false';
        return axios.get(url)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async getRevenuePickerAccounts(){
        const url = accounts_url + 'revenue_picker/';
        return axios.get(url)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async getExpensePickerAccounts(){
        const url = accounts_url + 'expense_picker/';
        return axios.get(url)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async getActiveAccountsPicker(){
        const url = accounts_url + 'active_picker/';
        return axios.get(url)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async getJournalEntryLines(id){
        const url = journal_entry_line_items_url + `?journal_entry_pk=${id}`;
        return axios.get(url)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async getJournalEntry(id){
        const url = journal_entry_url + `${id}/`;
        return axios.get(url)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async updateJournalEntry(id, journal_entry){
        const url = journal_entry_url + `${id}/`;
        return axios.patch(url, journal_entry)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async createJournalEntry(journal_entry){
        return axios.post(journal_entry_url, journal_entry)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async createJournalEntryLineItem(line_item){
        return axios.post(journal_entry_line_items_url, line_item)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async updateJournalEntryLineItem(id, line_item){
        const url = journal_entry_line_items_url + `${id}/`;
        return axios.patch(url, line_item)
        .then((response) => {
          return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
      },
    async getReconciliationAccounts(){
        const url = accounts_url + '?requires_reconciliation=true&archived=false';
        return axios.get(url)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
      },
      async getReconciliations(account_id){
        const url = reconciliations_url + `?account=${account_id}`;
        return axios.get(url)
        .then((response) => {
          return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
      },
      async getLegacyStatements(){
        return axios.get(reconciliations_url)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        })
      },
      async getUnreconciledLines(account_id, from_date, to_date){
        let url = journal_entry_line_items_url + `?account=${account_id}&reconciliation__isnull=true&`
        
        if(from_date !== null && from_date !== undefined){
            url += `from_date=${from_date}&`;
        }

        if(to_date !== null && to_date !== undefined){
            url += `to_date=${to_date}&`;
        }
        return axios.get(url)
        .then((response) => {
          return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
      },
      async getReconciledLines(id){
        const url = journal_entry_line_items_url + `?reconciliation=${id}`;
        return axios.get(url)
        .then((response) => {
          return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
      },
      async getReconciliation(id){
        const url = reconciliations_url + `${id}/`;
        return axios.get(url)
        .then((response) => {
          return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
      },
      async createReconciliation(reconciliation){
        return axios.post(reconciliations_url, reconciliation)
        .then((response) => {
          return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
      },
      async updateReconciliation(id, reconciliation){
        const url = reconciliations_url + `${id}/`;
        return axios.patch(url, reconciliation)
        .then((response) => {
          return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
      },
    async getDeposits(){
        const url = deposits_url + '?is_credit_card=false&';
        return axios.get(url)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async getCreditCardBatches(){
        const url = deposits_url + '?is_credit_card=true&';
        return axios.get(url)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async getUnclearedDeposits(){
        const url = deposits_url + '?reconciliation__isnull=true&';
        return axios.get(url)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async getDepositsForReconciliation(id){
        const url = deposits_url + `?reconciliation=${id}`;
        return axios.get(url)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async getDeposit(id){
        const url = deposits_url + `${id}/`;
        return axios.get(url)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async createDeposit(deposit){
        return axios.post(deposits_url, deposit)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async updateDeposit(id, deposit){
        const url = deposits_url + `${id}/`;
        return axios.patch(url, deposit).then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    // CHANGE // Filter this in the backend query
    async getUndepositedPayments(){
        const url = invoice_payments_url + '?deposit__isnull=true';
        // We don't want credit card payments here or eTransfers.
        // V is credit card, E is eTransfer
        return axios.get(url)
        .then((response) => {
            return response.data.filter(p => p.payment_method !== 'V' && p.payment_method !== 'E')
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    // CHANGE // check on the page, the note doesn't match the query
    async getPaymentsForDeposit(id){
        const url = invoice_payments_url + `?deposit=${id}`;
        // We don't want credit card payments here or eTransfers
        return axios.get(url)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async getExpenses () {
        return axios.get(expenses_url)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async getUnclearedExpenses () {
        const url = expenses_url + '?reconciliation__isnull=true';
        return axios.get(url)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async getExpensesForReconciliation (id) {
        const url = expenses_url + `?reconciliation=${id}`;

        return axios.get(url)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async getExpense (id) {
        const url = expenses_url + `${id}/`;

        return axios.get(url)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async createExpense (expense) {
        return axios.post(expenses_url, expense)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async updateExpense (id, expense) {
        const url = expenses_url + `${id}/`;
        return axios.patch(url, expense)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async deleteExpense (id) {
        const url = expenses_url + `${id}/`;
        return axios.delete(url)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async getExpenseLineItems (id) {
        const url = expense_line_items_url + `?expense=${id}`;
        return axios.get(url)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async getExpenseLineItem (id) {
        const url = expense_line_items_url + `${id}/`;
        return axios.get(url)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async getBudgetItemExpenses (id) {
        const url = expense_line_items_url + `?budget_line_item=${id}`;
        return axios.get(url)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async createExpenseLineItem (expense_line_item) {
        return axios.post(expense_line_items_url, expense_line_item)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async updateExpenseLineItem (id, expense_line_item) {
        const url = expense_line_items_url + `${id}/`;
        return axios.patch(url, expense_line_item)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async deleteExpenseLineItem (id) {
        const url = expense_line_items_url + `${id}/`;
        return axios.delete(url)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async getInvoiceTemplates(){
        return axios.get(invoice_templates_url)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async createInvoiceTemplate(template){
        return axios.post(invoice_templates_url, template)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async previewInvoiceTemplate(invoiceId, html){
        const url = preview_invoice_template_url + `${invoiceId}/`;
        return axios.post(url, { html })
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
    async activateInvoiceTemplate(id){
        const url = activate_invoice_template_url + `${id}/`;
        return axios.post(url)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
}
